import { ActionCreator } from 'redux';
import { CountriesMap, Country, EArticleAlias, IArticle } from '../types';
import * as ActionTypes from './actionTypes';

export const LegalsInitAction: ActionCreator<ActionTypes.ILegalsInitAction> = () => ({
  type: ActionTypes.LEGALS_INIT,
});

export const translationsReadyAction: ActionCreator<ActionTypes.ITranslationsReadyAction> = () => ({
  type: ActionTypes.TRANSLATIONS_READY,
});

export const legalsUpdateCountriesAction: ActionCreator<ActionTypes.ILegalsCountriesUpdateAction> = (
  countries: CountriesMap,
  mostCommon: Country[]
) => ({
  type: ActionTypes.LEGALS_COUNTRIES_UPDATE,
  countries,
  mostCommon,
});

export const legalsRequestAction: ActionCreator<ActionTypes.ILegalsRequestAction> = (
  articleAlias: EArticleAlias,
  country: string
) => ({
  type: ActionTypes.LEGALS_REQUEST,
  articleAlias,
  country,
});

export const legalsLoadedAction: ActionCreator<ActionTypes.ILegalsLoadedAction> = (articles: IArticle[]) => ({
  type: ActionTypes.LEGALS_LOADED,
  articles,
});

export const legalsFailedAction: ActionCreator<ActionTypes.ILegalsFailedAction> = (message: string) => ({
  type: ActionTypes.LEGALS_FAILED,
  message,
});
